import React, { FC } from 'react';
import { DealPreviewStyledAC } from './AC/DealPreviewStyled.AC';
import { DealPreviewStyledOV } from './OV/DealPreviewStyled.OV';
import { DealPreviewStyledOVGB } from './OV/GB/DealPreviewStyled.OV';
import { DealPreviewStyledAP } from './AP/DealPreviewStyled.AP';
import { DealPreviewStyledDS } from './DS/DealPreviewStyled.DS';
import { DealPreviewStyled } from './DealPreviewStyled';
import { SC } from '../../styles/theme';
import { getBrand } from '../../constants';
import { BrandTypes } from '../../types/brands';
import { isMarketGB } from '../../constants/main';

export const DealPreview: FC<SC & { id?: string }> = (props: SC & { id?: string }) => {
    if (getBrand() === BrandTypes.AC) return <DealPreviewStyledAC {...props} />;
    if (getBrand() === BrandTypes.OV)
        return isMarketGB ? <DealPreviewStyledOVGB {...props} /> : <DealPreviewStyledOV {...props} />;
    if (getBrand() === BrandTypes.AP) return <DealPreviewStyledAP {...props} />;
    if (getBrand() === BrandTypes.DS) return <DealPreviewStyledDS {...props} />;
    return <DealPreviewStyled {...props} />;
};
